import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import React from 'react';
import styles from './challengeDialog.module.css';
import { Category } from '../../../types/Category';
import { ChallengeMode } from '../../../types/enums';


export interface ChallengeDialogProps{
    open?: boolean;
    onClose?: (event?: {}, reason?: "backdropClick" | "escapeKeyDown") => any;
    challenge?: Category;
    onContinue?: ()=> void;
    mode?: ChallengeMode;
}

const ChallengeDialog: React.FC<ChallengeDialogProps> = ({
    open = false, onClose, challenge, onContinue, mode
})=>{
       
    return(
        <Dialog
            maxWidth= 'lg'
            PaperProps={{
                sx:{
                    backgroundColor: 'rgba(255, 255, 255, 1)',
                    width:'60%',
                    minHeight: '50%'
                }
            }}
            open={open}
            onClose={onClose}
            aria-labelledby="category-edit-dialog-title"
            aria-describedby="alert-category-description"
        >
            {/* <DialogTitle sx={{ textAlign: 'center' }}>Description </DialogTitle> */}
            <DialogContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                <div className={`${styles.stamp} ${mode === ChallengeMode.SUDDEN_DEATH && styles.suddenDeath}`}>
                    <div className={mode === ChallengeMode.SUDDEN_DEATH ? styles.suddenDeath : styles.fixed}>
                        <pre style={{ whiteSpace: 'pre-line' }}>
                            <span style={{ fontSize: 20 }}>
                                {challenge?.description}
                            </span>
                        </pre>
                    </div>
                </div>
            </DialogContent>
            <div className={styles.continueBtn}>
                <button 
                    onClick={onContinue}
                    className={`${styles.zoom} ${mode === ChallengeMode.SUDDEN_DEATH && styles.suddenBtn}`}
                >
                    Continue
                </button>
            </div>
        </Dialog>
    )
}

export default ChallengeDialog;